import { render } from "./datanotfound.vue?vue&type=template&id=2024d0d0"
import script from "./datanotfound.vue?vue&type=script&lang=js"
export * from "./datanotfound.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__